import './js/darkmode';
import './js/themoviedb';
import './js/fetchAPI';
import './js/pagination';

// import './js/render-gallery';
import './js/libraryStorage';
import './js/modalTeam';
// import './js/searchInput';

import './js/modal';
import './js/trailer';
// import './js/filter';

import './js/spinner';
import './js/btn-up';
